import { Col, Divider, Empty, Row } from "antd";
import { Gutter } from "antd/es/grid/row";
import { observer } from "mobx-react-lite";
import React from "react";
import { Project } from "../../../../js/parsegenerated";
import { ProjectContextProvider } from "../context/ProjectContext";
import { useProjectsManager } from "../hooks/useProjectsManager";
import { ProjectCardWrapper } from "./ProjectCardWrapper";
import { ProjectListView } from "./ProjectListView";

type Props = {
  projects: Project[];
  title?: string;
  hideSubProjects?: boolean;
  emptyMessage?: string;
};

export const ProjectGrid = observer((props: Props) => {
  const projectsManager = useProjectsManager();

  const span = { xxl: 8, xl: 12, lg: 12, md: 12, sm: 24, xs: 24 };
  const gutterSize: Gutter = { lg: 16, md: 8, sm: 8, xs: 8 };
  const gutter: [Gutter, Gutter] = [gutterSize, gutterSize];

  if (projectsManager.currentView === "list") {
    for (const key in span) {
      span[key] = 24;
    }
  }

  return (
    <>
      {props.title && <Divider children={props.title} />}
      {props.projects.length === 0 && props.emptyMessage && (
        <Empty description={props.emptyMessage} />
      )}
      {props.projects.length > 0 && (
        <Row gutter={gutter} align="stretch">
          {props.projects.map((project) => (
            <ProjectContextProvider value={project} key={project.id}>
              <Col {...span}>
                {projectsManager.currentView === "list" && <ProjectListView />}
                {projectsManager.currentView === "card" && (
                  <ProjectCardWrapper hideSubProjects={props.hideSubProjects} />
                )}
              </Col>
            </ProjectContextProvider>
          ))}
        </Row>
      )}
    </>
  );
});
